import './scss/style.scss';

import smoothScroll from '../../src/js/components/smooth-scroll';
import lazyLoadImages from '../../src/js/components/lazy-load-images';
import formRegister from '../../partials/form-register/js/components/form-register';
import ELSASlider from '../premium-new-user/js/slider';
import premiumScripts from './js/scripts';
import packageSlider from './js/package-slider';

$(function () {
  lazyLoadImages();
  ELSASlider();
  smoothScroll();
  formRegister();
  premiumScripts();
  packageSlider();
});

$(window).on('scroll', function () {
  lazyLoadImages();
});
